import styled from "styled-components";

export const DiversityIndexStyle = styled.div`
    width: 100%;
`;